module.exports = __webpack_public_path__ + "img/djdj.6b19b4a6.svg";